/*                                      */

/**
 *
 *
 */
export const VERSION = '5.25.6';
export const PUBLIC_VERSION = '5';
